interface ITitle {
  mainPart: string;
  highlightedPart: string;
}

export const prepareTitle = (title: string): ITitle => {
  const priceRegex = /(от\s[\d\s]+₽\/мес)/i;
  const match = title.match(priceRegex);

  let mainPart = title;
  let highlightedPart = '';

  if (match && match.index !== undefined) {
    const fullMatch = match[0];
    const startIndex = match.index;
    mainPart = title.substring(0, startIndex).trim();
    highlightedPart = fullMatch;
  }

  return { mainPart, highlightedPart };
};
